export function validateURL(url: string): string {
  const regex = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/g;
  if (url && url.match(regex) && !url.startsWith('http://') && !url.startsWith('https://') && !url.startsWith('mailto:')) {
    const match = regex.exec(url);
    // if it's @something.com, then it's an email and don't add http
    if (match && url.slice(match.index - 1, match.index) !== '@') {
      return `http://${url}`;
    }
  }
  return url;
}
